import addAgencyIdAndExecuteFinishToRender from 'utils/addAgencyIdAndExecuteFinishToRender'
import enableSaveQuoteAgent from 'core/controllerPlans/enableSaveQuoteAgent'
import detailsPlanFromAgent from 'core/controllerPlans/detailsPlanFromAgent'
import config from 'sites/enroll.pivothealth.com/start-application/config'
import isSalesCenterAgent from 'utils/pivot/agent/isSalesCenterAgent'
import trustPilotInit from 'pug/mixins/trustPilot/loadFromElems' // cspell:disable-line
import stickySummary from './components/plan-summary/sticky'
import registryListenersDOM from './registryListenersDOM'
import { IS_AGENT } from 'core/constants/environment'
import { START_APPLICATION } from 'sites/routes'
import textContent from 'utils/DOM/textContent'
import toggleClass from 'utils/DOM/toggleClass'
import curry from 'utils/functional/curry'
import tooltip from 'core/DOM/tooltip'

function finish(data) {
  // general

  registryListenersDOM()
  tooltip.init()
  trustPilotInit()
  stickySummary()

  if (IS_AGENT) {
    isSalesCenterAgent(data.hcStorage.agent_id).then(salesCenterAgent => {
      enableSaveQuoteAgent(() => {
        toggleClass('#email-quote-singular', 'd-block', true)
        textContent('.js-details-link', 'Email this quote')
      }, curry(detailsPlanFromAgent)({ config, path: START_APPLICATION, salesCenterAgent }))
    })
  }

  addAgencyIdAndExecuteFinishToRender()
}

export default finish
